import React from 'react';
import { Box, useTheme } from '@mui/material';
import { RADIUS } from '../../theme/tokens';

/**
 * GlassCard
 * Frosted-glass card using backdrop-filter. Falls back to a solid background
 * when backdrop-filter is unsupported.
 *
 * @param {number} blur - blur radius in px (default 12)
 * @param {'light'|'dark'|'auto'} tint - glass tint direction
 * @param {boolean} border - show a subtle border (default true in light mode)
 * @param {object} sx
 */
function GlassCard({ blur = 12, tint = 'auto', border, sx = {}, children, ...rest }) {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';

  const useBorder = border != null ? border : isLight;

  const tintColor =
    tint === 'light'
      ? 'rgba(255,255,255,0.6)'
      : tint === 'dark'
      ? 'rgba(15,23,42,0.5)'
      : isLight
      ? 'rgba(255,255,255,0.6)'
      : 'rgba(18,26,43,0.6)';

  return (
    <Box
      sx={{
        backdropFilter: `blur(${blur}px)`,
        WebkitBackdropFilter: `blur(${blur}px)`,
        // Solid fallback when backdrop-filter not supported
        '@supports not (backdrop-filter: blur(1px))': {
          backgroundColor: theme.palette.background.paper,
        },
        backgroundColor: tintColor,
        borderRadius: RADIUS.lg,
        border: useBorder ? `1px solid ${theme.palette.divider}` : 'none',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}

export default GlassCard;
